<template>
  <v-snackbar
    v-model="snackbarVisibility"
    :timeout="timeout"
  >
    {{snackBar}}
    <v-btn
      dark
      flat
      @click="snackbarVisibility = false"
    >
      Zamknij
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'main-snackbar',
  data: () => ({
    timeout: 6000,
  }),
  computed: {
    ...mapGetters('app', [
      'snackBar',
    ]),
    snackbarVisibility: {
      get() {
        return this.snackBar !== false;
      },
      set() {
        this.setSnackBar(false);
      },
    },
  },
  methods: {
    ...mapActions('app', [
      'setSnackBar',
    ]),
  },
  watch: {
  },
};
</script>
